import { OrderQuantityWithKit } from '../../../../@types/python.d';

export const getCheckedoutQuantity = ({
	orderQuantitiesWithKits,
	orderId,
	excludeOrderId,
	kitId,
}: {
	orderQuantitiesWithKits: OrderQuantityWithKit[] | undefined;
	orderId?: string;
	/** When set, omit this order's quantities (e.g. absolute max on the current checkout). */
	excludeOrderId?: string;
	kitId?: string | null;
}) =>
	orderQuantitiesWithKits?.reduce((total, orderQuantity) => {
		const orderMatch = orderId ? orderQuantity.orderId == orderId : true;
		const isNotExcludedOrder = excludeOrderId ? orderQuantity.orderId != excludeOrderId : true;
		const kitMatch = kitId !== undefined ? orderQuantity.kitId == kitId : true;
		if (orderMatch && isNotExcludedOrder && kitMatch) {
			total += orderQuantity.quantity;
		}
		return total;
	}, 0) ?? 0;

export const getLooseCheckedoutQuantity = (orderQuantitiesWithKits: OrderQuantityWithKit[] | undefined) =>
	getCheckedoutQuantity({
		orderQuantitiesWithKits,
		kitId: null,
	});
